import React from "react";
import { useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { NavMenu } from "@/components/NavMenu";
import { SportyPeopleBadge } from "@/components/SportyPeople";

export function BrandHeader() {
  const navigate = useNavigate();
  return (
    <header className="sticky top-0 z-40 bg-white/90 backdrop-blur-xl border-b border-slate-200">
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-3">
        <div className="flex flex-col leading-tight text-left">
          <button data-testid="header-logo" onClick={() => navigate("/inicio")} className="text-sm sm:text-lg font-black brand-navy text-left">
            Actividades de día y Viajes en la Naturaleza
          </button>
          <span className="text-[11px] sm:text-xs font-bold text-slate-500 mt-0.5">Grupos de Empresa de Repsol</span>
          <SportyPeopleBadge compact className="mt-0.5" />
        </div>
        <NavMenu />
      </div>
    </header>
  );
}
